<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_1078_30)">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z" fill="currentColor"/>
	<path fill-rule="evenodd" clip-rule="evenodd" d="M5 21C3.50714 21 3 20.2772 3 19C3 15.6863 5.68629 13 9 13H15C18.3137 13 21 15.6863 21 19C21 20.2772 20.4929 21 19 21C12.157 21 6.61471 21 5 21Z" fill="currentColor"/>
	</g>
	<defs>
	<clipPath id="clip0_1078_30">
	<rect width="24" height="24" fill="white"/>
	</clipPath>
	</defs>
	</svg>
	